<script>
import BusienssService from "@/services/Business";

export default {
  props: ['selectedData'],
  data() {
    return {
      editableUserReservations: {},
        errorMessage:''
    };
  },
  watch: {
      selectedData: {
      handler(newVal) {
        this.editableUserReservations = { ...newVal };
      },
      immediate: true,
    },
  },
  methods: {
    async saveChanges() {
      const payload = {
          reservation: this.editableUserReservations.reservation,
          customer_id:this.editableUserReservations.customer_id,
      };

      try {
        const response = await BusienssService.updateUserReservations(this.selectedData.event_id, payload);
        // console.log(response,'res in modal')
        if (response.data.success) {
          // Emit event for parent to update after save
          this.$emit('update-success', this.editableUserReservations);
          this.$emit('onRefresh');  // Emit refreshTable only after saving
          this.$bvModal.hide('edit_user_reservations');  // Close the modal after save
        } else {
          this.errorMessage = response.data.error;
          throw new Error('Failed to save changes');
        }
      } catch (error) {
        this.errorMessage = error.response.data.error[0];
        console.error("Error updating reservations:", error);
      }
    },

    closeModal() {
      // Only hide the modal, no page reload or table refresh here
      this.$bvModal.hide('edit_user_reservations');

    },
  }

};
</script>

<template>
  <b-modal id="edit_user_reservations" title="Edit Reservation" @hidden="closeModal" size="md" centered>
    <template v-slot:default>
      <div class="row">
        <div class="col-12">
          <b-form-group label="Reservation">
            <b-form-input type="number"  v-model="editableUserReservations.reservation" min="1"/>
              <p class="text-danger" v-if="errorMessage">{{errorMessage}}</p>
          </b-form-group>
        </div>
      </div>
    </template>
    <template v-slot:modal-footer style="justify-content: flex-start">
      <b-button variant="light" @click="closeModal">Cancel</b-button>
      <b-button  variant="primary" @click="saveChanges">Save Changes</b-button>
    </template>
  </b-modal>
</template>
